export const movies = {
    page: 1,
    results: [
      {
        adult: false,
        backdrop_path: "/6EdKBYkB1ssgGjc249ud1L55o8d.jpg",
        genre_ids: [28, 878, 53],
        id: 848278,
        original_language: "en",
        original_title: "Jurassic Hunt",
        overview:
          "Female adventurer Parker joins a crew of male trophy hunters in a remote wilderness park. Their goal: slaughter genetically recreated dinosaurs for sport using rifles, arrows, and grenades. After their guide is killed by raptors, the team tries to escape the park – but the hunters quickly become the hunted. Even worse, the park’s manager suspects Parker of being a spy and sends a hit squad after her. This battle’s about to become primitive!",
        popularity: 4475.053,
        poster_path: "/Czhr00kB8awffakEcQS5ON1ELm.jpg",
        release_date: "2021-08-23",
        title: "Jurassic Hunt",
        video: false,
        vote_average: 4.7,
        vote_count: 50,
      },
      {
        adult: false,
        backdrop_path: "/nDLylQOoIazGyYuWhk21Yww5FCb.jpg",
        genre_ids: [28, 12, 14],
        id: 566525,
        original_language: "en",
        original_title: "Shang-Chi and the Legend of the Ten Rings",
        overview:
          "Shang-Chi must confront the past he thought he left behind when he is drawn into the web of the mysterious Ten Rings organization.",
        popularity: 3247.45,
        poster_path: "/pS1XUGjC6ASC1kvDCP3OJnwjk1t.jpg",
        release_date: "2021-09-01",
        title: "Shang-Chi and the Legend of the Ten Rings",
        video: false,
        vote_average: 8,
        vote_count: 691,
      },
      {
        adult: false,
        backdrop_path: "/pUc51UUQb1lMLVVkDCaZVsCo37U.jpg",
        genre_ids: [53, 27],
        id: 482373,
        original_language: "en",
        original_title: "Don't Breathe 2",
        overview:
          "The Blind Man has been hiding out for several years in an isolated cabin and has taken in and raised a young girl orphaned from a devastating house fire. Their quiet life together is shattered when a group of criminals kidnap the girl, forcing the Blind Man to leave his safe haven to save her.",
        popularity: 3048.408,
        poster_path: "/hRMfgGFRAZIlvwVWy8DYJdLTpvN.jpg",
        release_date: "2021-08-12",
        title: "Don't Breathe 2",
        video: false,
        vote_average: 7.6,
        vote_count: 493,
      },
      {
        adult: false,
        backdrop_path: "/kiBYF6GW0KZ7R5dyCPUtkF4EiGo.jpg",
        genre_ids: [28, 878, 12],
        id: 588228,
        original_language: "en",
        original_title: "The Tomorrow War",
        overview:
          "The world is stunned when a group of time travelers arrive from the year 2051 to deliver an urgent message: Thirty years in the future, mankind is losing a global war against a deadly alien species. The only hope for survival is for soldiers and civilians from the present to be transported to the future and join the fight. Among those recruited is high school teacher and family man Dan Forester. Determined to save the world for his young daughter, Dan teams up with a brilliant scientist and his estranged father in a desperate quest to rewrite the fate of the planet.",
        popularity: 3266.921,
        poster_path: "/34nDCQZwaEvsy4CFO5hkGRFDCVU.jpg",
        release_date: "2021-09-03",
        title: "The Tomorrow War",
        video: false,
        vote_average: 7.6,
        vote_count: 369,
      },
      {
        adult: false,
        backdrop_path: "/jlGmlFOcfo8n5tURmhC7YVd4Iyy.jpg",
        genre_ids: [28, 12, 14, 35],
        id: 436969,
        original_language: "en",
        original_title: "The Suicide Squad",
        overview:
          "Supervillains Harley Quinn, Bloodsport, Peacemaker and a collection of nutty cons at Belle Reve prison join the super-secret, super-shady Task Force X as they are dropped off at the remote, enemy-infused island of Corto Maltese.",
        popularity: 3168.796,
        poster_path: "/kb4s0ML0iVZlG6wAKbbs9NAm6X.jpg",
        release_date: "2021-07-28",
        title: "The Suicide Squad",
        video: false,
        vote_average: 8,
        vote_count: 3707,
      },
      {
        adult: false,
        backdrop_path: "/vD8oPUpDUZDTGI5IVofxrUjxxUO.jpg",
        genre_ids: [28, 53],
        id: 595743,
        original_language: "en",
        original_title: "SAS: Red Notice",
        overview:
          "An off-duty SAS soldier, Tom Buckingham, must thwart a terror attack on a train running through the Channel Tunnel. As the action escalates on the train, events transpire in the corridors of power that may make the difference as to whether Buckingham and the civilian passengers make it out of the tunnel alive.",
        popularity: 2933.874,
        poster_path: "/6Y9fl8tD1xtyUrOHV2MkCYTpzgi.jpg",
        release_date: "2021-08-11",
        title: "SAS: Red Notice",
        video: false,
        vote_average: 6,
        vote_count: 129,
      },
      {
        adult: false,
        backdrop_path: "/uRkRJjrxVa04w7k83Hy20FKot4G.jpg",
        genre_ids: [28],
        id: 859041,
        original_language: "zh",
        original_title: "疯狂的拳头",
        overview:
          "Action  A mixed martial arts champion is forced out of retirement for one last fight in order to unravel a major conspiracy.",
        popularity: 2249.252,
        poster_path: "/z21p0pm82RbHrUyHj8Mu4tOEun5.jpg",
        release_date: "2021-05-06",
        title: "疯狂的拳头",
        video: false,
        vote_average: 7.6,
        vote_count: 21,
      },
      {
        adult: false,
        backdrop_path: "/7WJjFviFBffEJvkAms4uWwbcVUk.jpg",
        genre_ids: [12, 14, 35, 28],
        id: 451048,
        original_language: "en",
        original_title: "Jungle Cruise",
        overview:
          "Dr. Lily Houghton enlists the aid of wisecracking skipper Frank Wolff to take her down the Amazon in his dilapidated boat. Together, they search for an ancient tree that holds the power to heal – a discovery that will change the future of medicine.",
        popularity: 2422.668,
        poster_path: "/9dKCd55IuTT5QRs989m9Qlb7d2B.jpg",
        release_date: "2021-07-28",
        title: "Jungle Cruise",
        video: false,
        vote_average: 7.9,
        vote_count: 2517,
      },
      {
        adult: false,
        backdrop_path: "/849RDhbADVVnhtggR14dDBYejeN.jpg",
        genre_ids: [14, 10749, 35],
        id: 593910,
        original_language: "en",
        original_title: "Cinderella",
        overview:
          "Cinderella, an orphaned girl with an evil stepmother, has big dreams and with the help of her Fabulous Godmother, she perseveres to make them come true.",
        popularity: 2055.235,
        poster_path: "/clDFqATL4zcE7LzUwkrVj3zHvk7.jpg",
        release_date: "2021-09-03",
        title: "Cinderella",
        video: false,
        vote_average: 6.9,
        vote_count: 495,
      },
      {
        adult: false,
        backdrop_path: "/mtRW6eAwOO27h3zrfU2foQFW7Hg.jpg",
        genre_ids: [16, 10751, 12, 35],
        id: 675445,
        original_language: "en",
        original_title: "PAW Patrol: The Movie",
        overview:
          "Ryder and the pups are called to Adventure City to stop Mayor Humdinger from turning the bustling metropolis into a state of chaos.",
        popularity: 1977.179,
        poster_path: "/ic0intvXZSfBlYPIvWXpU1ivUCO.jpg",
        release_date: "2021-08-09",
        title: "PAW Patrol: The Movie",
        video: false,
        vote_average: 8,
        vote_count: 388,
      },
      {
        adult: false,
        backdrop_path: "/1Txzm4bY5ZDqvgMl7MmHeBMl7HH.jpg",
        genre_ids: [80, 18, 53],
        id: 860425,
        original_language: "es",
        original_title: "Sinaliento",
        overview:
          "In the DR, hardened cop Manolo tries to take down an infamous drug cartel; meanwhile, his daughter has fallen in love with Lorenzo, a construction worker who's unwittingly gotten embroiled in the drug cartel's dealings.",
        popularity: 1705.286,
        poster_path: "/oxNoVgbu2v9ETL93Kri1pw8osYf.jpg",
        release_date: "2021-08-11",
        title: "Breathless",
        video: false,
        vote_average: 6.5,
        vote_count: 22,
      },
      {
        adult: false,
        backdrop_path: "/dq18nCTTLpy9PmtzZI6Y2yAgdw5.jpg",
        genre_ids: [28, 12, 53, 878],
        id: 497698,
        original_language: "en",
        original_title: "Black Widow",
        overview:
          "Natasha Romanoff, also known as Black Widow, confronts the darker parts of her ledger when a dangerous conspiracy with ties to her past arises. Pursued by a force that will stop at nothing to bring her down, Natasha must deal with her history as a spy and the broken relationships left in her wake long before she became an Avenger.",
        popularity: 2110.202,
        poster_path: "/qAZ0pzat24kLdO3o8ejmbLxyOac.jpg",
        release_date: "2021-07-07",
        title: "Black Widow",
        video: false,
        vote_average: 7.8,
        vote_count: 4925,
      },
      {
        adult: false,
        backdrop_path: "/nprqOIEfiMMQx16lgKeLf3rmPrR.jpg",
        genre_ids: [28, 53, 18],
        id: 619297,
        original_language: "en",
        original_title: "Sweet Girl",
        overview:
          "A devastated husband vows to bring justice to the people responsible for his wife's death while protecting the only family he has left, his daughter.",
        popularity: 2090.347,
        poster_path: "/cP7odDzzFBD9ycxj2laTeFWGLjD.jpg",
        release_date: "2021-08-18",
        title: "Sweet Girl",
        video: false,
        vote_average: 6.9,
        vote_count: 511,
      },
      {
        adult: false,
        backdrop_path: "/dssCw0mUmD4EriUmkwB3PnsGu4q.jpg",
        genre_ids: [16, 28, 14],
        id: 841755,
        original_language: "en",
        original_title: "Mortal Kombat Legends: Battle of the Realms",
        overview:
          "The Earthrealm heroes must journey to the Outworld and fight for the survival of their homeland, invaded by the forces of evil warlord Shao Kahn, in the tournament to end all tournaments: the final Mortal Kombat.",
        popularity: 1777.011,
        poster_path: "/ablrE8IbWcIrAxMmm4gnPn75AMS.jpg",
        release_date: "2021-08-30",
        title: "Mortal Kombat Legends: Battle of the Realms",
        video: false,
        vote_average: 8.2,
        vote_count: 94,
      },
      {
        adult: false,
        backdrop_path: "/8s4h9friP6Ci3adRGahHARVd76E.jpg",
        genre_ids: [16, 35, 10751, 878],
        id: 379686,
        original_language: "en",
        original_title: "Space Jam: A New Legacy",
        overview:
          "When LeBron and his young son Dom are trapped in a digital space by a rogue A.I., LeBron must get them home safe by leading Bugs, Lola Bunny and the whole gang of notoriously undisciplined Looney Tunes to victory over the A.I.'s digitized champions on the court. It's Tunes versus Goons in the highest-stakes challenge of his life.",
        popularity: 1854.026,
        poster_path: "/5bFK5d3mVTAvBCXi5NPWH0tYjKl.jpg",
        release_date: "2021-07-08",
        title: "Space Jam: A New Legacy",
        video: false,
        vote_average: 7.4,
        vote_count: 2141,
      },
      {
        adult: false,
        backdrop_path: "/8Y43POKjjKDGI9MH89NW0NAzzp8.jpg",
        genre_ids: [35, 28, 12, 878],
        id: 550988,
        original_language: "en",
        original_title: "Free Guy",
        overview:
          "A bank teller called Guy realizes he is a background character in an open world video game called Free City that will soon go offline.",
        popularity: 1515.122,
        poster_path: "/yc2IfL701hGkNHRgzmF4C6VKO14.jpg",
        release_date: "2021-08-11",
        title: "Free Guy",
        video: false,
        vote_average: 7.7,
        vote_count: 619,
      },
      {
        adult: false,
        backdrop_path: "/xXHZeb1yhJvnSHPzZDqee0zfMb6.jpg",
        genre_ids: [28, 80, 53],
        id: 385128,
        original_language: "en",
        original_title: "F9",
        overview:
          "Dominic Toretto and his crew battle the most skilled assassin and high-performance driver they've ever encountered: his forsaken brother.",
        popularity: 1648.35,
        poster_path: "/bOFaAXmWWXC3Rbv4u4uM9ZSzRXP.jpg",
        release_date: "2021-05-19",
        title: "F9",
        video: false,
        vote_average: 7.5,
        vote_count: 3555,
      },
      {
        adult: false,
        backdrop_path: "/wjQXZTlFM3PVEUmKf1sUajjygqT.jpg",
        genre_ids: [878, 28, 53],
        id: 581726,
        original_language: "en",
        original_title: "Infinite",
        overview:
          "Evan McCauley has skills he never learned and memories of places he has never visited. Self-medicated and on the brink of a mental breakdown, a secret group that call themselves “Infinites” come to his rescue, revealing that his memories are real.",
        popularity: 1557.1,
        poster_path: "/niw2AKHz6XmwiRMLWaoyAOAti0G.jpg",
        release_date: "2021-06-10",
        title: "Infinite",
        video: false,
        vote_average: 7.4,
        vote_count: 1009,
      },
      {
        adult: false,
        backdrop_path: "/620hnMVLu6RSZW6a5rwO8gqpt0t.jpg",
        genre_ids: [16, 35, 10751, 14],
        id: 508943,
        original_language: "en",
        original_title: "Luca",
        overview:
          "Luca and his best friend Alberto experience an unforgettable summer on the Italian Riviera. But all the fun is threatened by a deeply-held secret: they are sea monsters from another world just below the water’s surface.",
        popularity: 1480.653,
        poster_path: "/jTswp6KyDYKtvC52GbHagrZbGvD.jpg",
        release_date: "2021-06-17",
        title: "Luca",
        video: false,
        vote_average: 8.1,
        vote_count: 4416,
      },
      {
        adult: false,
        backdrop_path: "/qD45xHA35HdJDGOaA1AgDwiWEgO.jpg",
        genre_ids: [10749, 18],
        id: 744275,
        original_language: "en",
        original_title: "After We Fell",
        overview:
          "Just as Tessa's life begins to become unglued, nothing is what she thought it would be. Not her friends nor her family. The only person that she should be able to rely on is Hardin, who is furious when he discovers the massive secret that she's been keeping. Before Tessa makes the biggest decision of her life, everything changes because of revelations about her family.",
        popularity: 1232.869,
        poster_path: "/oOZITZodAja6optBgLh8ZZrgzbb.jpg",
        release_date: "2021-09-01",
        title: "After We Fell",
        video: false,
        vote_average: 8.5,
        vote_count: 212,
      },
    ],
    total_pages: 500,
    total_results: 10000,
  };
  
  //db -> fetch() -> take time -> loader 